exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_listElementHeader_20o3v1xo9j-zVg_YP-JVKm {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  overflow: hidden;\n  font-size: 12px;\n  padding-left: 15px;\n  box-sizing: border-box;\n}\n\n.IA_previewColumn_2ySKoHMvX5ciDMFMcxMohb {\n  flex: 0.2;\n}\n\n.IA_iconColumn_Z0MHnTBGEU-Cqh0uyCDeX {\n  flex: 0.4;\n  padding-right: 10px;\n  box-sizing: border-box;\n}\n\n.IA_dateColumn_Qn0THNZf1_Yg9nxlflO3q {\n  flex: 0.5;\n}\n\n.IA_column_1Nr0cXUz0jHkZwb-F8PeV1 {\n  flex: 1;\n}\n\n.IA_buttons_o5kHVZsG9rm9P0RTHlCFH {\n  padding-right: 10px;\n}", ""]);

// Exports
exports.locals = {
	"IA_listElementHeader": "IA_listElementHeader_20o3v1xo9j-zVg_YP-JVKm",
	"IA_previewColumn": "IA_previewColumn_2ySKoHMvX5ciDMFMcxMohb",
	"IA_iconColumn": "IA_iconColumn_Z0MHnTBGEU-Cqh0uyCDeX",
	"IA_dateColumn": "IA_dateColumn_Qn0THNZf1_Yg9nxlflO3q",
	"IA_column": "IA_column_1Nr0cXUz0jHkZwb-F8PeV1",
	"IA_buttons": "IA_buttons_o5kHVZsG9rm9P0RTHlCFH"
};